/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Reflex API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AddOrgEmailDomainBody
} from './model/addOrgEmailDomainBody.js';

import type {
  AddOrgMemberBody
} from './model/addOrgMemberBody.js';

import type {
  AdminSetOrgSandboxProviderBody
} from './model/adminSetOrgSandboxProviderBody.js';

import type {
  AdminSetOrgSecretBody
} from './model/adminSetOrgSecretBody.js';

import type {
  AdminValidateOrgSandboxProviderBody
} from './model/adminValidateOrgSandboxProviderBody.js';

import type {
  AssignOrgRoleBody
} from './model/assignOrgRoleBody.js';

import type {
  BaseImageView
} from './model/baseImageView.js';

import type {
  CreateOrgInviteBody
} from './model/createOrgInviteBody.js';

import type {
  CreateOrgModelProviderSecretBody
} from './model/createOrgModelProviderSecretBody.js';

import type {
  CreateOrgTeamBody
} from './model/createOrgTeamBody.js';

import type {
  CreateOrganizationBody
} from './model/createOrganizationBody.js';

import type {
  CreateOrganizationInviteResponse
} from './model/createOrganizationInviteResponse.js';

import type {
  CreateTeamModelProviderSecretBody
} from './model/createTeamModelProviderSecretBody.js';

import type {
  CreateTeamSecretBody
} from './model/createTeamSecretBody.js';

import type {
  GetIdpConfig200
} from './model/getIdpConfig200.js';

import type {
  ListLlmTaskAssignments200
} from './model/listLlmTaskAssignments200.js';

import type {
  ListOrgInvitesParams
} from './model/listOrgInvitesParams.js';

import type {
  ListOrgModelProviderSecretDependents200
} from './model/listOrgModelProviderSecretDependents200.js';

import type {
  ListOrgTeams200
} from './model/listOrgTeams200.js';

import type {
  ListOrganizationsResponse
} from './model/listOrganizationsResponse.js';

import type {
  ListTeamSecrets200
} from './model/listTeamSecrets200.js';

import type {
  LlmTaskAssignment
} from './model/llmTaskAssignment.js';

import type {
  ModelProviderSecret
} from './model/modelProviderSecret.js';

import type {
  Organization
} from './model/organization.js';

import type {
  RevokeOrgRoleBody
} from './model/revokeOrgRoleBody.js';

import type {
  RotateScimToken200
} from './model/rotateScimToken200.js';

import type {
  ScopedSecret
} from './model/scopedSecret.js';

import type {
  SetBaseImageOverridesBody
} from './model/setBaseImageOverridesBody.js';

import type {
  SetOrgPluginSettingsBody
} from './model/setOrgPluginSettingsBody.js';

import type {
  UpdateOrgModelProviderSecretBody
} from './model/updateOrgModelProviderSecretBody.js';

import type {
  UpdateOrgRoleBody
} from './model/updateOrgRoleBody.js';

import type {
  UpdateOrganizationBody
} from './model/updateOrganizationBody.js';

import type {
  UpdateTeamModelProviderSecretBody
} from './model/updateTeamModelProviderSecretBody.js';

import type {
  UpdateTeamSecretBody
} from './model/updateTeamSecretBody.js';

import type {
  UpsertIdpConfig200
} from './model/upsertIdpConfig200.js';

import type {
  UpsertIdpConfigBody
} from './model/upsertIdpConfigBody.js';

import type {
  UpsertLlmTaskAssignmentBody
} from './model/upsertLlmTaskAssignmentBody.js';

import { apiFetch } from '../react-mutator.js';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary List the organizations you belong to.
 */
export const listOrganizations = (

 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<ListOrganizationsResponse>(
      {url: `/organizations`, method: 'GET', signal
    },
      options);
    }




export const getListOrganizationsQueryKey = () => {
    return [
    `/organizations`
    ] as const;
    }


export const getListOrganizationsQueryOptions = <TData = Awaited<ReturnType<typeof listOrganizations>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOrganizations>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOrganizationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOrganizations>>> = ({ signal }) => listOrganizations(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOrganizations>>, TError, TData> & { queryKey: QueryKey }
}

export type ListOrganizationsQueryResult = NonNullable<Awaited<ReturnType<typeof listOrganizations>>>
export type ListOrganizationsQueryError = unknown


/**
 * @summary List the organizations you belong to.
 */

export function useListOrganizations<TData = Awaited<ReturnType<typeof listOrganizations>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOrganizations>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListOrganizationsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Create an organization with you as its owner.
 */
export const createOrganization = (
    createOrganizationBody: CreateOrganizationBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/organizations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createOrganizationBody, signal
    },
      options);
    }




export const getCreateOrganizationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrganization>>, TError,{data: CreateOrganizationBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createOrganization>>, TError,{data: CreateOrganizationBody}, TContext> => {

const mutationKey = ['createOrganization'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOrganization>>, {data: CreateOrganizationBody}> = (props) => {
          const {data} = props ?? {};

          return  createOrganization(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof createOrganization>>>
    export type CreateOrganizationMutationBody = CreateOrganizationBody
    export type CreateOrganizationMutationError = unknown

    /**
 * @summary Create an organization with you as its owner.
 */
export const useCreateOrganization = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrganization>>, TError,{data: CreateOrganizationBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createOrganization>>,
        TError,
        {data: CreateOrganizationBody},
        TContext
      > => {
      return useMutation(getCreateOrganizationMutationOptions(options));
    }
    /**
 * @summary Get an organization by id.
 */
export const getOrganization = (
    id: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<Organization>(
      {url: `/organizations/${encodeURIComponent(String(id))}`, method: 'GET', signal
    },
      options);
    }




export const getGetOrganizationQueryKey = (id: string,) => {
    return [
    `/organizations/${id}`
    ] as const;
    }


export const getGetOrganizationQueryOptions = <TData = Awaited<ReturnType<typeof getOrganization>>, TError = unknown>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrganization>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganizationQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganization>>> = ({ signal }) => getOrganization(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrganization>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOrganizationQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganization>>>
export type GetOrganizationQueryError = unknown


/**
 * @summary Get an organization by id.
 */

export function useGetOrganization<TData = Awaited<ReturnType<typeof getOrganization>>, TError = unknown>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrganization>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOrganizationQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Capability changes are restricted to platform admins.
 * @summary Update an organization's name, slug, or settings.
 */
export const updateOrganization = (
    id: string,
    updateOrganizationBody: UpdateOrganizationBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/organizations/${encodeURIComponent(String(id))}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateOrganizationBody, signal
    },
      options);
    }




export const getUpdateOrganizationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrganization>>, TError,{id: string;data: UpdateOrganizationBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOrganization>>, TError,{id: string;data: UpdateOrganizationBody}, TContext> => {

const mutationKey = ['updateOrganization'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOrganization>>, {id: string;data: UpdateOrganizationBody}> = (props) => {
          const {id,data} = props ?? {};

          return  updateOrganization(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof updateOrganization>>>
    export type UpdateOrganizationMutationBody = UpdateOrganizationBody
    export type UpdateOrganizationMutationError = unknown

    /**
 * @summary Update an organization's name, slug, or settings.
 */
export const useUpdateOrganization = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrganization>>, TError,{id: string;data: UpdateOrganizationBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateOrganization>>,
        TError,
        {id: string;data: UpdateOrganizationBody},
        TContext
      > => {
      return useMutation(getUpdateOrganizationMutationOptions(options));
    }
    /**
 * Hard-deletes the organization and every org-scoped record with it: teams, members, roles, secrets, agents, invites, and plugin data. This cannot be undone.
 * @summary Permanently delete an organization and all of its data.
 */
export const deleteOrganization = (
    id: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/organizations/${encodeURIComponent(String(id))}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteOrganizationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOrganization>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteOrganization>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteOrganization'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteOrganization>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteOrganization(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteOrganization>>>

    export type DeleteOrganizationMutationError = unknown

    /**
 * @summary Permanently delete an organization and all of its data.
 */
export const useDeleteOrganization = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOrganization>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteOrganization>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteOrganizationMutationOptions(options));
    }
    /**
 * @summary Report the org's base image commands and build status.
 */
export const getBaseImage = (
    id: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<BaseImageView>(
      {url: `/organizations/${encodeURIComponent(String(id))}/base-image`, method: 'GET', signal
    },
      options);
    }




export const getGetBaseImageQueryKey = (id: string,) => {
    return [
    `/organizations/${id}/base-image`
    ] as const;
    }


export const getGetBaseImageQueryOptions = <TData = Awaited<ReturnType<typeof getBaseImage>>, TError = unknown>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBaseImage>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBaseImageQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBaseImage>>> = ({ signal }) => getBaseImage(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBaseImage>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBaseImageQueryResult = NonNullable<Awaited<ReturnType<typeof getBaseImage>>>
export type GetBaseImageQueryError = unknown


/**
 * @summary Report the org's base image commands and build status.
 */

export function useGetBaseImage<TData = Awaited<ReturnType<typeof getBaseImage>>, TError = unknown>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBaseImage>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetBaseImageQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Saving starts a background base image rebuild; the response returns before the build finishes.
 * @summary Save the org's base image override commands.
 */
export const setBaseImageOverrides = (
    id: string,
    setBaseImageOverridesBody: SetBaseImageOverridesBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/organizations/${encodeURIComponent(String(id))}/base-image/overrides`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setBaseImageOverridesBody, signal
    },
      options);
    }




export const getSetBaseImageOverridesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setBaseImageOverrides>>, TError,{id: string;data: SetBaseImageOverridesBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setBaseImageOverrides>>, TError,{id: string;data: SetBaseImageOverridesBody}, TContext> => {

const mutationKey = ['setBaseImageOverrides'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setBaseImageOverrides>>, {id: string;data: SetBaseImageOverridesBody}> = (props) => {
          const {id,data} = props ?? {};

          return  setBaseImageOverrides(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetBaseImageOverridesMutationResult = NonNullable<Awaited<ReturnType<typeof setBaseImageOverrides>>>
    export type SetBaseImageOverridesMutationBody = SetBaseImageOverridesBody
    export type SetBaseImageOverridesMutationError = unknown

    /**
 * @summary Save the org's base image override commands.
 */
export const useSetBaseImageOverrides = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setBaseImageOverrides>>, TError,{id: string;data: SetBaseImageOverridesBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setBaseImageOverrides>>,
        TError,
        {id: string;data: SetBaseImageOverridesBody},
        TContext
      > => {
      return useMutation(getSetBaseImageOverridesMutationOptions(options));
    }
    /**
 * Kicks off the rebuild in the background and responds immediately with 202. Child blueprints rebuild after the base completes.
 * @summary Rebuild the org's base image.
 */
export const rebuildBaseImage = (
    id: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/organizations/${encodeURIComponent(String(id))}/base-image/rebuild`, method: 'POST', signal
    },
      options);
    }




export const getRebuildBaseImageMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rebuildBaseImage>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rebuildBaseImage>>, TError,{id: string}, TContext> => {

const mutationKey = ['rebuildBaseImage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rebuildBaseImage>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  rebuildBaseImage(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RebuildBaseImageMutationResult = NonNullable<Awaited<ReturnType<typeof rebuildBaseImage>>>

    export type RebuildBaseImageMutationError = unknown

    /**
 * @summary Rebuild the org's base image.
 */
export const useRebuildBaseImage = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rebuildBaseImage>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof rebuildBaseImage>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getRebuildBaseImageMutationOptions(options));
    }
    /**
 * @summary List company-owned email domains associated with the organization.
 */
export const listOrgEmailDomains = (
    id: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/organizations/${encodeURIComponent(String(id))}/email-domains`, method: 'GET', signal
    },
      options);
    }




export const getListOrgEmailDomainsQueryKey = (id: string,) => {
    return [
    `/organizations/${id}/email-domains`
    ] as const;
    }


export const getListOrgEmailDomainsQueryOptions = <TData = Awaited<ReturnType<typeof listOrgEmailDomains>>, TError = unknown>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOrgEmailDomains>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOrgEmailDomainsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOrgEmailDomains>>> = ({ signal }) => listOrgEmailDomains(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOrgEmailDomains>>, TError, TData> & { queryKey: QueryKey }
}

export type ListOrgEmailDomainsQueryResult = NonNullable<Awaited<ReturnType<typeof listOrgEmailDomains>>>
export type ListOrgEmailDomainsQueryError = unknown


/**
 * @summary List company-owned email domains associated with the organization.
 */

export function useListOrgEmailDomains<TData = Awaited<ReturnType<typeof listOrgEmailDomains>>, TError = unknown>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOrgEmailDomains>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListOrgEmailDomainsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Restricted to platform admins: the association lands the claim platform-approved, without DNS proof.
 * @summary Associate a company-owned email domain with an organization.
 */
export const addOrgEmailDomain = (
    id: string,
    addOrgEmailDomainBody: AddOrgEmailDomainBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/organizations/${encodeURIComponent(String(id))}/email-domains`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addOrgEmailDomainBody, signal
    },
      options);
    }




export const getAddOrgEmailDomainMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addOrgEmailDomain>>, TError,{id: string;data: AddOrgEmailDomainBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addOrgEmailDomain>>, TError,{id: string;data: AddOrgEmailDomainBody}, TContext> => {

const mutationKey = ['addOrgEmailDomain'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addOrgEmailDomain>>, {id: string;data: AddOrgEmailDomainBody}> = (props) => {
          const {id,data} = props ?? {};

          return  addOrgEmailDomain(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddOrgEmailDomainMutationResult = NonNullable<Awaited<ReturnType<typeof addOrgEmailDomain>>>
    export type AddOrgEmailDomainMutationBody = AddOrgEmailDomainBody
    export type AddOrgEmailDomainMutationError = unknown

    /**
 * @summary Associate a company-owned email domain with an organization.
 */
export const useAddOrgEmailDomain = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addOrgEmailDomain>>, TError,{id: string;data: AddOrgEmailDomainBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof addOrgEmailDomain>>,
        TError,
        {id: string;data: AddOrgEmailDomainBody},
        TContext
      > => {
      return useMutation(getAddOrgEmailDomainMutationOptions(options));
    }
    /**
 * Restricted to platform admins, like the association it removes.
 * @summary Remove an organization association with a company-owned email domain.
 */
export const removeOrgEmailDomain = (
    id: string,
    domain: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/organizations/${encodeURIComponent(String(id))}/email-domains/${encodeURIComponent(String(domain))}`, method: 'DELETE', signal
    },
      options);
    }




export const getRemoveOrgEmailDomainMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeOrgEmailDomain>>, TError,{id: string;domain: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removeOrgEmailDomain>>, TError,{id: string;domain: string}, TContext> => {

const mutationKey = ['removeOrgEmailDomain'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeOrgEmailDomain>>, {id: string;domain: string}> = (props) => {
          const {id,domain} = props ?? {};

          return  removeOrgEmailDomain(id,domain,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveOrgEmailDomainMutationResult = NonNullable<Awaited<ReturnType<typeof removeOrgEmailDomain>>>

    export type RemoveOrgEmailDomainMutationError = unknown

    /**
 * @summary Remove an organization association with a company-owned email domain.
 */
export const useRemoveOrgEmailDomain = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeOrgEmailDomain>>, TError,{id: string;domain: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof removeOrgEmailDomain>>,
        TError,
        {id: string;domain: string},
        TContext
      > => {
      return useMutation(getRemoveOrgEmailDomainMutationOptions(options));
    }
    /**
 * @summary List the organization's invites, filtered to pending by default.
 */
export const listOrgInvites = (
    id: string,
    params?: ListOrgInvitesParams,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/organizations/${encodeURIComponent(String(id))}/invites`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListOrgInvitesQueryKey = (id: string,
    params?: ListOrgInvitesParams,) => {
    return [
    `/organizations/${id}/invites`, ...(params ? [params] : [])
    ] as const;
    }


export const getListOrgInvitesQueryOptions = <TData = Awaited<ReturnType<typeof listOrgInvites>>, TError = unknown>(id: string,
    params?: ListOrgInvitesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOrgInvites>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOrgInvitesQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOrgInvites>>> = ({ signal }) => listOrgInvites(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOrgInvites>>, TError, TData> & { queryKey: QueryKey }
}

export type ListOrgInvitesQueryResult = NonNullable<Awaited<ReturnType<typeof listOrgInvites>>>
export type ListOrgInvitesQueryError = unknown


/**
 * @summary List the organization's invites, filtered to pending by default.
 */

export function useListOrgInvites<TData = Awaited<ReturnType<typeof listOrgInvites>>, TError = unknown>(
 id: string,
    params?: ListOrgInvitesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOrgInvites>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListOrgInvitesQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * The invite token and redeem link are returned in plaintext exactly once on this response and cannot be retrieved again.
 * @summary Invite a user to the organization by email.
 */
export const createOrgInvite = (
    id: string,
    createOrgInviteBody: CreateOrgInviteBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<CreateOrganizationInviteResponse>(
      {url: `/organizations/${encodeURIComponent(String(id))}/invites`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createOrgInviteBody, signal
    },
      options);
    }




export const getCreateOrgInviteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrgInvite>>, TError,{id: string;data: CreateOrgInviteBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createOrgInvite>>, TError,{id: string;data: CreateOrgInviteBody}, TContext> => {

const mutationKey = ['createOrgInvite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOrgInvite>>, {id: string;data: CreateOrgInviteBody}> = (props) => {
          const {id,data} = props ?? {};

          return  createOrgInvite(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOrgInviteMutationResult = NonNullable<Awaited<ReturnType<typeof createOrgInvite>>>
    export type CreateOrgInviteMutationBody = CreateOrgInviteBody
    export type CreateOrgInviteMutationError = unknown

    /**
 * @summary Invite a user to the organization by email.
 */
export const useCreateOrgInvite = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrgInvite>>, TError,{id: string;data: CreateOrgInviteBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createOrgInvite>>,
        TError,
        {id: string;data: CreateOrgInviteBody},
        TContext
      > => {
      return useMutation(getCreateOrgInviteMutationOptions(options));
    }
    /**
 * @summary Revoke an invite so its link can no longer be redeemed.
 */
export const revokeOrgInvite = (
    id: string,
    inviteId: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/organizations/${encodeURIComponent(String(id))}/invites/${encodeURIComponent(String(inviteId))}`, method: 'DELETE', signal
    },
      options);
    }




export const getRevokeOrgInviteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeOrgInvite>>, TError,{id: string;inviteId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof revokeOrgInvite>>, TError,{id: string;inviteId: string}, TContext> => {

const mutationKey = ['revokeOrgInvite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeOrgInvite>>, {id: string;inviteId: string}> = (props) => {
          const {id,inviteId} = props ?? {};

          return  revokeOrgInvite(id,inviteId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevokeOrgInviteMutationResult = NonNullable<Awaited<ReturnType<typeof revokeOrgInvite>>>

    export type RevokeOrgInviteMutationError = unknown

    /**
 * @summary Revoke an invite so its link can no longer be redeemed.
 */
export const useRevokeOrgInvite = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeOrgInvite>>, TError,{id: string;inviteId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof revokeOrgInvite>>,
        TError,
        {id: string;inviteId: string},
        TContext
      > => {
      return useMutation(getRevokeOrgInviteMutationOptions(options));
    }
    /**
 * The previously shared link stops working immediately. The replacement token and redeem link are returned in plaintext exactly once on this response and cannot be retrieved again.
 * @summary Expire an invite's current link and issue a fresh one.
 */
export const resendOrgInvite = (
    id: string,
    inviteId: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<CreateOrganizationInviteResponse>(
      {url: `/organizations/${encodeURIComponent(String(id))}/invites/${encodeURIComponent(String(inviteId))}/resend`, method: 'POST', signal
    },
      options);
    }




export const getResendOrgInviteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendOrgInvite>>, TError,{id: string;inviteId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof resendOrgInvite>>, TError,{id: string;inviteId: string}, TContext> => {

const mutationKey = ['resendOrgInvite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resendOrgInvite>>, {id: string;inviteId: string}> = (props) => {
          const {id,inviteId} = props ?? {};

          return  resendOrgInvite(id,inviteId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResendOrgInviteMutationResult = NonNullable<Awaited<ReturnType<typeof resendOrgInvite>>>

    export type ResendOrgInviteMutationError = unknown

    /**
 * @summary Expire an invite's current link and issue a fresh one.
 */
export const useResendOrgInvite = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendOrgInvite>>, TError,{id: string;inviteId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof resendOrgInvite>>,
        TError,
        {id: string;inviteId: string},
        TContext
      > => {
      return useMutation(getResendOrgInviteMutationOptions(options));
    }
    /**
 * @summary List the members of the organization and their roles.
 */
export const listOrgMembers = (
    id: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/organizations/${encodeURIComponent(String(id))}/members`, method: 'GET', signal
    },
      options);
    }




export const getListOrgMembersQueryKey = (id: string,) => {
    return [
    `/organizations/${id}/members`
    ] as const;
    }


export const getListOrgMembersQueryOptions = <TData = Awaited<ReturnType<typeof listOrgMembers>>, TError = unknown>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOrgMembers>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOrgMembersQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOrgMembers>>> = ({ signal }) => listOrgMembers(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOrgMembers>>, TError, TData> & { queryKey: QueryKey }
}

export type ListOrgMembersQueryResult = NonNullable<Awaited<ReturnType<typeof listOrgMembers>>>
export type ListOrgMembersQueryError = unknown


/**
 * @summary List the members of the organization and their roles.
 */

export function useListOrgMembers<TData = Awaited<ReturnType<typeof listOrgMembers>>, TError = unknown>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOrgMembers>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListOrgMembersQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Add an existing user to the organization.
 */
export const addOrgMember = (
    id: string,
    addOrgMemberBody: AddOrgMemberBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/organizations/${encodeURIComponent(String(id))}/members`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addOrgMemberBody, signal
    },
      options);
    }




export const getAddOrgMemberMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addOrgMember>>, TError,{id: string;data: AddOrgMemberBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addOrgMember>>, TError,{id: string;data: AddOrgMemberBody}, TContext> => {

const mutationKey = ['addOrgMember'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addOrgMember>>, {id: string;data: AddOrgMemberBody}> = (props) => {
          const {id,data} = props ?? {};

          return  addOrgMember(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddOrgMemberMutationResult = NonNullable<Awaited<ReturnType<typeof addOrgMember>>>
    export type AddOrgMemberMutationBody = AddOrgMemberBody
    export type AddOrgMemberMutationError = unknown

    /**
 * @summary Add an existing user to the organization.
 */
export const useAddOrgMember = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addOrgMember>>, TError,{id: string;data: AddOrgMemberBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof addOrgMember>>,
        TError,
        {id: string;data: AddOrgMemberBody},
        TContext
      > => {
      return useMutation(getAddOrgMemberMutationOptions(options));
    }
    /**
 * @summary Remove a member from the organization.
 */
export const removeOrgMember = (
    id: string,
    userId: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/organizations/${encodeURIComponent(String(id))}/members/${encodeURIComponent(String(userId))}`, method: 'DELETE', signal
    },
      options);
    }




export const getRemoveOrgMemberMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeOrgMember>>, TError,{id: string;userId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removeOrgMember>>, TError,{id: string;userId: string}, TContext> => {

const mutationKey = ['removeOrgMember'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeOrgMember>>, {id: string;userId: string}> = (props) => {
          const {id,userId} = props ?? {};

          return  removeOrgMember(id,userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveOrgMemberMutationResult = NonNullable<Awaited<ReturnType<typeof removeOrgMember>>>

    export type RemoveOrgMemberMutationError = unknown

    /**
 * @summary Remove a member from the organization.
 */
export const useRemoveOrgMember = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeOrgMember>>, TError,{id: string;userId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof removeOrgMember>>,
        TError,
        {id: string;userId: string},
        TContext
      > => {
      return useMutation(getRemoveOrgMemberMutationOptions(options));
    }
    /**
 * @summary List the org's installed, available, and system plugins.
 */
export const listOrgPlugins = (
    id: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/organizations/${encodeURIComponent(String(id))}/plugins`, method: 'GET', signal
    },
      options);
    }




export const getListOrgPluginsQueryKey = (id: string,) => {
    return [
    `/organizations/${id}/plugins`
    ] as const;
    }


export const getListOrgPluginsQueryOptions = <TData = Awaited<ReturnType<typeof listOrgPlugins>>, TError = unknown>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOrgPlugins>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOrgPluginsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOrgPlugins>>> = ({ signal }) => listOrgPlugins(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOrgPlugins>>, TError, TData> & { queryKey: QueryKey }
}

export type ListOrgPluginsQueryResult = NonNullable<Awaited<ReturnType<typeof listOrgPlugins>>>
export type ListOrgPluginsQueryError = unknown


/**
 * @summary List the org's installed, available, and system plugins.
 */

export function useListOrgPlugins<TData = Awaited<ReturnType<typeof listOrgPlugins>>, TError = unknown>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOrgPlugins>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListOrgPluginsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Report a plugin's installation status for the org.
 */
export const getOrgPlugin = (
    id: string,
    name: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/organizations/${encodeURIComponent(String(id))}/plugins/${encodeURIComponent(String(name))}`, method: 'GET', signal
    },
      options);
    }




export const getGetOrgPluginQueryKey = (id: string,
    name: string,) => {
    return [
    `/organizations/${id}/plugins/${name}`
    ] as const;
    }


export const getGetOrgPluginQueryOptions = <TData = Awaited<ReturnType<typeof getOrgPlugin>>, TError = unknown>(id: string,
    name: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrgPlugin>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrgPluginQueryKey(id,name);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrgPlugin>>> = ({ signal }) => getOrgPlugin(id,name, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && name !== null && name !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrgPlugin>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOrgPluginQueryResult = NonNullable<Awaited<ReturnType<typeof getOrgPlugin>>>
export type GetOrgPluginQueryError = unknown


/**
 * @summary Report a plugin's installation status for the org.
 */

export function useGetOrgPlugin<TData = Awaited<ReturnType<typeof getOrgPlugin>>, TError = unknown>(
 id: string,
    name: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrgPlugin>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOrgPluginQueryOptions(id,name,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Install a plugin for the organization.
 */
export const installOrgPlugin = (
    id: string,
    name: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/organizations/${encodeURIComponent(String(id))}/plugins/${encodeURIComponent(String(name))}/install`, method: 'POST', signal
    },
      options);
    }




export const getInstallOrgPluginMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof installOrgPlugin>>, TError,{id: string;name: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof installOrgPlugin>>, TError,{id: string;name: string}, TContext> => {

const mutationKey = ['installOrgPlugin'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof installOrgPlugin>>, {id: string;name: string}> = (props) => {
          const {id,name} = props ?? {};

          return  installOrgPlugin(id,name,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InstallOrgPluginMutationResult = NonNullable<Awaited<ReturnType<typeof installOrgPlugin>>>

    export type InstallOrgPluginMutationError = unknown

    /**
 * @summary Install a plugin for the organization.
 */
export const useInstallOrgPlugin = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof installOrgPlugin>>, TError,{id: string;name: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof installOrgPlugin>>,
        TError,
        {id: string;name: string},
        TContext
      > => {
      return useMutation(getInstallOrgPluginMutationOptions(options));
    }
    /**
 * @summary Read the org's settings for a plugin.
 */
export const getOrgPluginSettings = (
    id: string,
    name: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/organizations/${encodeURIComponent(String(id))}/plugins/${encodeURIComponent(String(name))}/settings`, method: 'GET', signal
    },
      options);
    }




export const getGetOrgPluginSettingsQueryKey = (id: string,
    name: string,) => {
    return [
    `/organizations/${id}/plugins/${name}/settings`
    ] as const;
    }


export const getGetOrgPluginSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getOrgPluginSettings>>, TError = unknown>(id: string,
    name: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrgPluginSettings>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrgPluginSettingsQueryKey(id,name);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrgPluginSettings>>> = ({ signal }) => getOrgPluginSettings(id,name, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && name !== null && name !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrgPluginSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOrgPluginSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getOrgPluginSettings>>>
export type GetOrgPluginSettingsQueryError = unknown


/**
 * @summary Read the org's settings for a plugin.
 */

export function useGetOrgPluginSettings<TData = Awaited<ReturnType<typeof getOrgPluginSettings>>, TError = unknown>(
 id: string,
    name: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrgPluginSettings>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOrgPluginSettingsQueryOptions(id,name,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Save the org's settings for a plugin.
 */
export const setOrgPluginSettings = (
    id: string,
    name: string,
    setOrgPluginSettingsBody: SetOrgPluginSettingsBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/organizations/${encodeURIComponent(String(id))}/plugins/${encodeURIComponent(String(name))}/settings`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setOrgPluginSettingsBody, signal
    },
      options);
    }




export const getSetOrgPluginSettingsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setOrgPluginSettings>>, TError,{id: string;name: string;data: SetOrgPluginSettingsBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setOrgPluginSettings>>, TError,{id: string;name: string;data: SetOrgPluginSettingsBody}, TContext> => {

const mutationKey = ['setOrgPluginSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setOrgPluginSettings>>, {id: string;name: string;data: SetOrgPluginSettingsBody}> = (props) => {
          const {id,name,data} = props ?? {};

          return  setOrgPluginSettings(id,name,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetOrgPluginSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof setOrgPluginSettings>>>
    export type SetOrgPluginSettingsMutationBody = SetOrgPluginSettingsBody
    export type SetOrgPluginSettingsMutationError = unknown

    /**
 * @summary Save the org's settings for a plugin.
 */
export const useSetOrgPluginSettings = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setOrgPluginSettings>>, TError,{id: string;name: string;data: SetOrgPluginSettingsBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setOrgPluginSettings>>,
        TError,
        {id: string;name: string;data: SetOrgPluginSettingsBody},
        TContext
      > => {
      return useMutation(getSetOrgPluginSettingsMutationOptions(options));
    }
    /**
 * @summary Uninstall a plugin from the organization.
 */
export const uninstallOrgPlugin = (
    id: string,
    name: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/organizations/${encodeURIComponent(String(id))}/plugins/${encodeURIComponent(String(name))}/uninstall`, method: 'POST', signal
    },
      options);
    }




export const getUninstallOrgPluginMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uninstallOrgPlugin>>, TError,{id: string;name: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof uninstallOrgPlugin>>, TError,{id: string;name: string}, TContext> => {

const mutationKey = ['uninstallOrgPlugin'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uninstallOrgPlugin>>, {id: string;name: string}> = (props) => {
          const {id,name} = props ?? {};

          return  uninstallOrgPlugin(id,name,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UninstallOrgPluginMutationResult = NonNullable<Awaited<ReturnType<typeof uninstallOrgPlugin>>>

    export type UninstallOrgPluginMutationError = unknown

    /**
 * @summary Uninstall a plugin from the organization.
 */
export const useUninstallOrgPlugin = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uninstallOrgPlugin>>, TError,{id: string;name: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof uninstallOrgPlugin>>,
        TError,
        {id: string;name: string},
        TContext
      > => {
      return useMutation(getUninstallOrgPluginMutationOptions(options));
    }
    /**
 * @summary List the dependent plugins an uninstall would also remove.
 */
export const previewOrgPluginUninstall = (
    id: string,
    name: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/organizations/${encodeURIComponent(String(id))}/plugins/${encodeURIComponent(String(name))}/uninstall-preview`, method: 'GET', signal
    },
      options);
    }




export const getPreviewOrgPluginUninstallQueryKey = (id: string,
    name: string,) => {
    return [
    `/organizations/${id}/plugins/${name}/uninstall-preview`
    ] as const;
    }


export const getPreviewOrgPluginUninstallQueryOptions = <TData = Awaited<ReturnType<typeof previewOrgPluginUninstall>>, TError = unknown>(id: string,
    name: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof previewOrgPluginUninstall>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPreviewOrgPluginUninstallQueryKey(id,name);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof previewOrgPluginUninstall>>> = ({ signal }) => previewOrgPluginUninstall(id,name, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && name !== null && name !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof previewOrgPluginUninstall>>, TError, TData> & { queryKey: QueryKey }
}

export type PreviewOrgPluginUninstallQueryResult = NonNullable<Awaited<ReturnType<typeof previewOrgPluginUninstall>>>
export type PreviewOrgPluginUninstallQueryError = unknown


/**
 * @summary List the dependent plugins an uninstall would also remove.
 */

export function usePreviewOrgPluginUninstall<TData = Awaited<ReturnType<typeof previewOrgPluginUninstall>>, TError = unknown>(
 id: string,
    name: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof previewOrgPluginUninstall>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPreviewOrgPluginUninstallQueryOptions(id,name,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary List the roles available in the organization.
 */
export const listOrgRoles = (
    id: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/organizations/${encodeURIComponent(String(id))}/roles`, method: 'GET', signal
    },
      options);
    }




export const getListOrgRolesQueryKey = (id: string,) => {
    return [
    `/organizations/${id}/roles`
    ] as const;
    }


export const getListOrgRolesQueryOptions = <TData = Awaited<ReturnType<typeof listOrgRoles>>, TError = unknown>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOrgRoles>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOrgRolesQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOrgRoles>>> = ({ signal }) => listOrgRoles(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOrgRoles>>, TError, TData> & { queryKey: QueryKey }
}

export type ListOrgRolesQueryResult = NonNullable<Awaited<ReturnType<typeof listOrgRoles>>>
export type ListOrgRolesQueryError = unknown


/**
 * @summary List the roles available in the organization.
 */

export function useListOrgRoles<TData = Awaited<ReturnType<typeof listOrgRoles>>, TError = unknown>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOrgRoles>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListOrgRolesQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Get a role and its permissions.
 */
export const getOrgRole = (
    id: string,
    roleId: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/organizations/${encodeURIComponent(String(id))}/roles/${encodeURIComponent(String(roleId))}`, method: 'GET', signal
    },
      options);
    }




export const getGetOrgRoleQueryKey = (id: string,
    roleId: string,) => {
    return [
    `/organizations/${id}/roles/${roleId}`
    ] as const;
    }


export const getGetOrgRoleQueryOptions = <TData = Awaited<ReturnType<typeof getOrgRole>>, TError = unknown>(id: string,
    roleId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrgRole>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrgRoleQueryKey(id,roleId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrgRole>>> = ({ signal }) => getOrgRole(id,roleId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && roleId !== null && roleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrgRole>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOrgRoleQueryResult = NonNullable<Awaited<ReturnType<typeof getOrgRole>>>
export type GetOrgRoleQueryError = unknown


/**
 * @summary Get a role and its permissions.
 */

export function useGetOrgRole<TData = Awaited<ReturnType<typeof getOrgRole>>, TError = unknown>(
 id: string,
    roleId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrgRole>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOrgRoleQueryOptions(id,roleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Built-in roles are immutable; changing one fails with 400.
 * @summary Update a custom role's name, description, or permissions.
 */
export const updateOrgRole = (
    id: string,
    roleId: string,
    updateOrgRoleBody: UpdateOrgRoleBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/organizations/${encodeURIComponent(String(id))}/roles/${encodeURIComponent(String(roleId))}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateOrgRoleBody, signal
    },
      options);
    }




export const getUpdateOrgRoleMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrgRole>>, TError,{id: string;roleId: string;data: UpdateOrgRoleBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOrgRole>>, TError,{id: string;roleId: string;data: UpdateOrgRoleBody}, TContext> => {

const mutationKey = ['updateOrgRole'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOrgRole>>, {id: string;roleId: string;data: UpdateOrgRoleBody}> = (props) => {
          const {id,roleId,data} = props ?? {};

          return  updateOrgRole(id,roleId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOrgRoleMutationResult = NonNullable<Awaited<ReturnType<typeof updateOrgRole>>>
    export type UpdateOrgRoleMutationBody = UpdateOrgRoleBody
    export type UpdateOrgRoleMutationError = unknown

    /**
 * @summary Update a custom role's name, description, or permissions.
 */
export const useUpdateOrgRole = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrgRole>>, TError,{id: string;roleId: string;data: UpdateOrgRoleBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateOrgRole>>,
        TError,
        {id: string;roleId: string;data: UpdateOrgRoleBody},
        TContext
      > => {
      return useMutation(getUpdateOrgRoleMutationOptions(options));
    }
    /**
 * @summary Assign a role to an organization member.
 */
export const assignOrgRole = (
    id: string,
    assignOrgRoleBody: AssignOrgRoleBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/organizations/${encodeURIComponent(String(id))}/roles/assign`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: assignOrgRoleBody, signal
    },
      options);
    }




export const getAssignOrgRoleMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignOrgRole>>, TError,{id: string;data: AssignOrgRoleBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof assignOrgRole>>, TError,{id: string;data: AssignOrgRoleBody}, TContext> => {

const mutationKey = ['assignOrgRole'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assignOrgRole>>, {id: string;data: AssignOrgRoleBody}> = (props) => {
          const {id,data} = props ?? {};

          return  assignOrgRole(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AssignOrgRoleMutationResult = NonNullable<Awaited<ReturnType<typeof assignOrgRole>>>
    export type AssignOrgRoleMutationBody = AssignOrgRoleBody
    export type AssignOrgRoleMutationError = unknown

    /**
 * @summary Assign a role to an organization member.
 */
export const useAssignOrgRole = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignOrgRole>>, TError,{id: string;data: AssignOrgRoleBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof assignOrgRole>>,
        TError,
        {id: string;data: AssignOrgRoleBody},
        TContext
      > => {
      return useMutation(getAssignOrgRoleMutationOptions(options));
    }
    /**
 * @summary Revoke a role from an organization member.
 */
export const revokeOrgRole = (
    id: string,
    revokeOrgRoleBody: RevokeOrgRoleBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/organizations/${encodeURIComponent(String(id))}/roles/revoke`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: revokeOrgRoleBody, signal
    },
      options);
    }




export const getRevokeOrgRoleMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeOrgRole>>, TError,{id: string;data: RevokeOrgRoleBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof revokeOrgRole>>, TError,{id: string;data: RevokeOrgRoleBody}, TContext> => {

const mutationKey = ['revokeOrgRole'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeOrgRole>>, {id: string;data: RevokeOrgRoleBody}> = (props) => {
          const {id,data} = props ?? {};

          return  revokeOrgRole(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevokeOrgRoleMutationResult = NonNullable<Awaited<ReturnType<typeof revokeOrgRole>>>
    export type RevokeOrgRoleMutationBody = RevokeOrgRoleBody
    export type RevokeOrgRoleMutationError = unknown

    /**
 * @summary Revoke a role from an organization member.
 */
export const useRevokeOrgRole = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeOrgRole>>, TError,{id: string;data: RevokeOrgRoleBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof revokeOrgRole>>,
        TError,
        {id: string;data: RevokeOrgRoleBody},
        TContext
      > => {
      return useMutation(getRevokeOrgRoleMutationOptions(options));
    }
    /**
 * @summary Report a target org's sandbox provider key and account.
 */
export const adminGetOrgSandboxProvider = (
    id: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/organizations/${encodeURIComponent(String(id))}/sandbox-provider`, method: 'GET', signal
    },
      options);
    }




export const getAdminGetOrgSandboxProviderQueryKey = (id: string,) => {
    return [
    `/organizations/${id}/sandbox-provider`
    ] as const;
    }


export const getAdminGetOrgSandboxProviderQueryOptions = <TData = Awaited<ReturnType<typeof adminGetOrgSandboxProvider>>, TError = unknown>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminGetOrgSandboxProvider>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminGetOrgSandboxProviderQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetOrgSandboxProvider>>> = ({ signal }) => adminGetOrgSandboxProvider(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminGetOrgSandboxProvider>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminGetOrgSandboxProviderQueryResult = NonNullable<Awaited<ReturnType<typeof adminGetOrgSandboxProvider>>>
export type AdminGetOrgSandboxProviderQueryError = unknown


/**
 * @summary Report a target org's sandbox provider key and account.
 */

export function useAdminGetOrgSandboxProvider<TData = Awaited<ReturnType<typeof adminGetOrgSandboxProvider>>, TError = unknown>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminGetOrgSandboxProvider>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminGetOrgSandboxProviderQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Validate and save a target org's sandbox provider API key.
 */
export const adminSetOrgSandboxProvider = (
    id: string,
    adminSetOrgSandboxProviderBody: AdminSetOrgSandboxProviderBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/organizations/${encodeURIComponent(String(id))}/sandbox-provider`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adminSetOrgSandboxProviderBody, signal
    },
      options);
    }




export const getAdminSetOrgSandboxProviderMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminSetOrgSandboxProvider>>, TError,{id: string;data: AdminSetOrgSandboxProviderBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminSetOrgSandboxProvider>>, TError,{id: string;data: AdminSetOrgSandboxProviderBody}, TContext> => {

const mutationKey = ['adminSetOrgSandboxProvider'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminSetOrgSandboxProvider>>, {id: string;data: AdminSetOrgSandboxProviderBody}> = (props) => {
          const {id,data} = props ?? {};

          return  adminSetOrgSandboxProvider(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminSetOrgSandboxProviderMutationResult = NonNullable<Awaited<ReturnType<typeof adminSetOrgSandboxProvider>>>
    export type AdminSetOrgSandboxProviderMutationBody = AdminSetOrgSandboxProviderBody
    export type AdminSetOrgSandboxProviderMutationError = unknown

    /**
 * @summary Validate and save a target org's sandbox provider API key.
 */
export const useAdminSetOrgSandboxProvider = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminSetOrgSandboxProvider>>, TError,{id: string;data: AdminSetOrgSandboxProviderBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof adminSetOrgSandboxProvider>>,
        TError,
        {id: string;data: AdminSetOrgSandboxProviderBody},
        TContext
      > => {
      return useMutation(getAdminSetOrgSandboxProviderMutationOptions(options));
    }
    /**
 * @summary Report whether a target org's stored sandbox key works.
 */
export const adminGetOrgSandboxProviderHealth = (
    id: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/organizations/${encodeURIComponent(String(id))}/sandbox-provider/health`, method: 'GET', signal
    },
      options);
    }




export const getAdminGetOrgSandboxProviderHealthQueryKey = (id: string,) => {
    return [
    `/organizations/${id}/sandbox-provider/health`
    ] as const;
    }


export const getAdminGetOrgSandboxProviderHealthQueryOptions = <TData = Awaited<ReturnType<typeof adminGetOrgSandboxProviderHealth>>, TError = unknown>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminGetOrgSandboxProviderHealth>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminGetOrgSandboxProviderHealthQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetOrgSandboxProviderHealth>>> = ({ signal }) => adminGetOrgSandboxProviderHealth(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminGetOrgSandboxProviderHealth>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminGetOrgSandboxProviderHealthQueryResult = NonNullable<Awaited<ReturnType<typeof adminGetOrgSandboxProviderHealth>>>
export type AdminGetOrgSandboxProviderHealthQueryError = unknown


/**
 * @summary Report whether a target org's stored sandbox key works.
 */

export function useAdminGetOrgSandboxProviderHealth<TData = Awaited<ReturnType<typeof adminGetOrgSandboxProviderHealth>>, TError = unknown>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminGetOrgSandboxProviderHealth>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminGetOrgSandboxProviderHealthQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Check a sandbox provider API key against a target org's pin without saving it.
 */
export const adminValidateOrgSandboxProvider = (
    id: string,
    adminValidateOrgSandboxProviderBody: AdminValidateOrgSandboxProviderBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/organizations/${encodeURIComponent(String(id))}/sandbox-provider/validate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminValidateOrgSandboxProviderBody, signal
    },
      options);
    }




export const getAdminValidateOrgSandboxProviderMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminValidateOrgSandboxProvider>>, TError,{id: string;data: AdminValidateOrgSandboxProviderBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminValidateOrgSandboxProvider>>, TError,{id: string;data: AdminValidateOrgSandboxProviderBody}, TContext> => {

const mutationKey = ['adminValidateOrgSandboxProvider'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminValidateOrgSandboxProvider>>, {id: string;data: AdminValidateOrgSandboxProviderBody}> = (props) => {
          const {id,data} = props ?? {};

          return  adminValidateOrgSandboxProvider(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminValidateOrgSandboxProviderMutationResult = NonNullable<Awaited<ReturnType<typeof adminValidateOrgSandboxProvider>>>
    export type AdminValidateOrgSandboxProviderMutationBody = AdminValidateOrgSandboxProviderBody
    export type AdminValidateOrgSandboxProviderMutationError = unknown

    /**
 * @summary Check a sandbox provider API key against a target org's pin without saving it.
 */
export const useAdminValidateOrgSandboxProvider = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminValidateOrgSandboxProvider>>, TError,{id: string;data: AdminValidateOrgSandboxProviderBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof adminValidateOrgSandboxProvider>>,
        TError,
        {id: string;data: AdminValidateOrgSandboxProviderBody},
        TContext
      > => {
      return useMutation(getAdminValidateOrgSandboxProviderMutationOptions(options));
    }
    /**
 * @summary Save a target org's secret by name.
 */
export const adminSetOrgSecret = (
    id: string,
    name: string,
    adminSetOrgSecretBody: AdminSetOrgSecretBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/organizations/${encodeURIComponent(String(id))}/secrets/${encodeURIComponent(String(name))}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adminSetOrgSecretBody, signal
    },
      options);
    }




export const getAdminSetOrgSecretMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminSetOrgSecret>>, TError,{id: string;name: string;data: AdminSetOrgSecretBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminSetOrgSecret>>, TError,{id: string;name: string;data: AdminSetOrgSecretBody}, TContext> => {

const mutationKey = ['adminSetOrgSecret'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminSetOrgSecret>>, {id: string;name: string;data: AdminSetOrgSecretBody}> = (props) => {
          const {id,name,data} = props ?? {};

          return  adminSetOrgSecret(id,name,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminSetOrgSecretMutationResult = NonNullable<Awaited<ReturnType<typeof adminSetOrgSecret>>>
    export type AdminSetOrgSecretMutationBody = AdminSetOrgSecretBody
    export type AdminSetOrgSecretMutationError = unknown

    /**
 * @summary Save a target org's secret by name.
 */
export const useAdminSetOrgSecret = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminSetOrgSecret>>, TError,{id: string;name: string;data: AdminSetOrgSecretBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof adminSetOrgSecret>>,
        TError,
        {id: string;name: string;data: AdminSetOrgSecretBody},
        TContext
      > => {
      return useMutation(getAdminSetOrgSecretMutationOptions(options));
    }
    /**
 * @summary Report which of a target org's secrets are set.
 */
export const adminGetOrgSecretsStatus = (
    id: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/organizations/${encodeURIComponent(String(id))}/secrets/status`, method: 'GET', signal
    },
      options);
    }




export const getAdminGetOrgSecretsStatusQueryKey = (id: string,) => {
    return [
    `/organizations/${id}/secrets/status`
    ] as const;
    }


export const getAdminGetOrgSecretsStatusQueryOptions = <TData = Awaited<ReturnType<typeof adminGetOrgSecretsStatus>>, TError = unknown>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminGetOrgSecretsStatus>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminGetOrgSecretsStatusQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetOrgSecretsStatus>>> = ({ signal }) => adminGetOrgSecretsStatus(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminGetOrgSecretsStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminGetOrgSecretsStatusQueryResult = NonNullable<Awaited<ReturnType<typeof adminGetOrgSecretsStatus>>>
export type AdminGetOrgSecretsStatusQueryError = unknown


/**
 * @summary Report which of a target org's secrets are set.
 */

export function useAdminGetOrgSecretsStatus<TData = Awaited<ReturnType<typeof adminGetOrgSecretsStatus>>, TError = unknown>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminGetOrgSecretsStatus>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminGetOrgSecretsStatusQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary List the teams in the organization.
 */
export const listOrgTeams = (
    id: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<ListOrgTeams200>(
      {url: `/organizations/${encodeURIComponent(String(id))}/teams`, method: 'GET', signal
    },
      options);
    }




export const getListOrgTeamsQueryKey = (id: string,) => {
    return [
    `/organizations/${id}/teams`
    ] as const;
    }


export const getListOrgTeamsQueryOptions = <TData = Awaited<ReturnType<typeof listOrgTeams>>, TError = unknown>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOrgTeams>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOrgTeamsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOrgTeams>>> = ({ signal }) => listOrgTeams(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOrgTeams>>, TError, TData> & { queryKey: QueryKey }
}

export type ListOrgTeamsQueryResult = NonNullable<Awaited<ReturnType<typeof listOrgTeams>>>
export type ListOrgTeamsQueryError = unknown


/**
 * @summary List the teams in the organization.
 */

export function useListOrgTeams<TData = Awaited<ReturnType<typeof listOrgTeams>>, TError = unknown>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOrgTeams>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListOrgTeamsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Create a team and join it as its maintainer.
 */
export const createOrgTeam = (
    id: string,
    createOrgTeamBody: CreateOrgTeamBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/organizations/${encodeURIComponent(String(id))}/teams`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createOrgTeamBody, signal
    },
      options);
    }




export const getCreateOrgTeamMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrgTeam>>, TError,{id: string;data: CreateOrgTeamBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createOrgTeam>>, TError,{id: string;data: CreateOrgTeamBody}, TContext> => {

const mutationKey = ['createOrgTeam'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOrgTeam>>, {id: string;data: CreateOrgTeamBody}> = (props) => {
          const {id,data} = props ?? {};

          return  createOrgTeam(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOrgTeamMutationResult = NonNullable<Awaited<ReturnType<typeof createOrgTeam>>>
    export type CreateOrgTeamMutationBody = CreateOrgTeamBody
    export type CreateOrgTeamMutationError = unknown

    /**
 * @summary Create a team and join it as its maintainer.
 */
export const useCreateOrgTeam = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrgTeam>>, TError,{id: string;data: CreateOrgTeamBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createOrgTeam>>,
        TError,
        {id: string;data: CreateOrgTeamBody},
        TContext
      > => {
      return useMutation(getCreateOrgTeamMutationOptions(options));
    }
    /**
 * @summary Get the org's enterprise IdP configuration.
 */
export const getIdpConfig = (
    organizationId: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<GetIdpConfig200>(
      {url: `/organizations/${encodeURIComponent(String(organizationId))}/idp-config`, method: 'GET', signal
    },
      options);
    }




export const getGetIdpConfigQueryKey = (organizationId: string,) => {
    return [
    `/organizations/${organizationId}/idp-config`
    ] as const;
    }


export const getGetIdpConfigQueryOptions = <TData = Awaited<ReturnType<typeof getIdpConfig>>, TError = unknown>(organizationId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getIdpConfig>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIdpConfigQueryKey(organizationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIdpConfig>>> = ({ signal }) => getIdpConfig(organizationId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: organizationId !== null && organizationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIdpConfig>>, TError, TData> & { queryKey: QueryKey }
}

export type GetIdpConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getIdpConfig>>>
export type GetIdpConfigQueryError = unknown


/**
 * @summary Get the org's enterprise IdP configuration.
 */

export function useGetIdpConfig<TData = Awaited<ReturnType<typeof getIdpConfig>>, TError = unknown>(
 organizationId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getIdpConfig>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetIdpConfigQueryOptions(organizationId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Create or update the org's enterprise IdP configuration.
 */
export const upsertIdpConfig = (
    organizationId: string,
    upsertIdpConfigBody: UpsertIdpConfigBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<UpsertIdpConfig200>(
      {url: `/organizations/${encodeURIComponent(String(organizationId))}/idp-config`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: upsertIdpConfigBody, signal
    },
      options);
    }




export const getUpsertIdpConfigMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertIdpConfig>>, TError,{organizationId: string;data: UpsertIdpConfigBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof upsertIdpConfig>>, TError,{organizationId: string;data: UpsertIdpConfigBody}, TContext> => {

const mutationKey = ['upsertIdpConfig'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertIdpConfig>>, {organizationId: string;data: UpsertIdpConfigBody}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  upsertIdpConfig(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpsertIdpConfigMutationResult = NonNullable<Awaited<ReturnType<typeof upsertIdpConfig>>>
    export type UpsertIdpConfigMutationBody = UpsertIdpConfigBody
    export type UpsertIdpConfigMutationError = unknown

    /**
 * @summary Create or update the org's enterprise IdP configuration.
 */
export const useUpsertIdpConfig = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertIdpConfig>>, TError,{organizationId: string;data: UpsertIdpConfigBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof upsertIdpConfig>>,
        TError,
        {organizationId: string;data: UpsertIdpConfigBody},
        TContext
      > => {
      return useMutation(getUpsertIdpConfigMutationOptions(options));
    }
    /**
 * @summary Mint a fresh SCIM bearer token for the org's IdP, replacing any previous one.
 */
export const rotateScimToken = (
    organizationId: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<RotateScimToken200>(
      {url: `/organizations/${encodeURIComponent(String(organizationId))}/idp-config/scim-token`, method: 'POST', signal
    },
      options);
    }




export const getRotateScimTokenMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rotateScimToken>>, TError,{organizationId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rotateScimToken>>, TError,{organizationId: string}, TContext> => {

const mutationKey = ['rotateScimToken'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rotateScimToken>>, {organizationId: string}> = (props) => {
          const {organizationId} = props ?? {};

          return  rotateScimToken(organizationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RotateScimTokenMutationResult = NonNullable<Awaited<ReturnType<typeof rotateScimToken>>>

    export type RotateScimTokenMutationError = unknown

    /**
 * @summary Mint a fresh SCIM bearer token for the org's IdP, replacing any previous one.
 */
export const useRotateScimToken = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rotateScimToken>>, TError,{organizationId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof rotateScimToken>>,
        TError,
        {organizationId: string},
        TContext
      > => {
      return useMutation(getRotateScimTokenMutationOptions(options));
    }
    /**
 * @summary List the org's LLM task assignments.
 */
export const listLlmTaskAssignments = (
    organizationId: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<ListLlmTaskAssignments200>(
      {url: `/organizations/${encodeURIComponent(String(organizationId))}/llm-task-assignments`, method: 'GET', signal
    },
      options);
    }




export const getListLlmTaskAssignmentsQueryKey = (organizationId: string,) => {
    return [
    `/organizations/${organizationId}/llm-task-assignments`
    ] as const;
    }


export const getListLlmTaskAssignmentsQueryOptions = <TData = Awaited<ReturnType<typeof listLlmTaskAssignments>>, TError = unknown>(organizationId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listLlmTaskAssignments>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLlmTaskAssignmentsQueryKey(organizationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLlmTaskAssignments>>> = ({ signal }) => listLlmTaskAssignments(organizationId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: organizationId !== null && organizationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLlmTaskAssignments>>, TError, TData> & { queryKey: QueryKey }
}

export type ListLlmTaskAssignmentsQueryResult = NonNullable<Awaited<ReturnType<typeof listLlmTaskAssignments>>>
export type ListLlmTaskAssignmentsQueryError = unknown


/**
 * @summary List the org's LLM task assignments.
 */

export function useListLlmTaskAssignments<TData = Awaited<ReturnType<typeof listLlmTaskAssignments>>, TError = unknown>(
 organizationId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listLlmTaskAssignments>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListLlmTaskAssignmentsQueryOptions(organizationId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Save the org's model and key assignment for an LLM task.
 */
export const upsertLlmTaskAssignment = (
    organizationId: string,
    taskId: 'agent-summary' | 'slack-interaction' | 'change-summary',
    upsertLlmTaskAssignmentBody: UpsertLlmTaskAssignmentBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<LlmTaskAssignment>(
      {url: `/organizations/${encodeURIComponent(String(organizationId))}/llm-task-assignments/${encodeURIComponent(String(taskId))}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: upsertLlmTaskAssignmentBody, signal
    },
      options);
    }




export const getUpsertLlmTaskAssignmentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertLlmTaskAssignment>>, TError,{organizationId: string;taskId: 'agent-summary' | 'slack-interaction' | 'change-summary';data: UpsertLlmTaskAssignmentBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof upsertLlmTaskAssignment>>, TError,{organizationId: string;taskId: 'agent-summary' | 'slack-interaction' | 'change-summary';data: UpsertLlmTaskAssignmentBody}, TContext> => {

const mutationKey = ['upsertLlmTaskAssignment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertLlmTaskAssignment>>, {organizationId: string;taskId: 'agent-summary' | 'slack-interaction' | 'change-summary';data: UpsertLlmTaskAssignmentBody}> = (props) => {
          const {organizationId,taskId,data} = props ?? {};

          return  upsertLlmTaskAssignment(organizationId,taskId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpsertLlmTaskAssignmentMutationResult = NonNullable<Awaited<ReturnType<typeof upsertLlmTaskAssignment>>>
    export type UpsertLlmTaskAssignmentMutationBody = UpsertLlmTaskAssignmentBody
    export type UpsertLlmTaskAssignmentMutationError = unknown

    /**
 * @summary Save the org's model and key assignment for an LLM task.
 */
export const useUpsertLlmTaskAssignment = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertLlmTaskAssignment>>, TError,{organizationId: string;taskId: 'agent-summary' | 'slack-interaction' | 'change-summary';data: UpsertLlmTaskAssignmentBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof upsertLlmTaskAssignment>>,
        TError,
        {organizationId: string;taskId: 'agent-summary' | 'slack-interaction' | 'change-summary';data: UpsertLlmTaskAssignmentBody},
        TContext
      > => {
      return useMutation(getUpsertLlmTaskAssignmentMutationOptions(options));
    }
    /**
 * @summary List the org's model provider keys.
 */
export const listOrgModelProviderSecrets = (
    organizationId: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/organizations/${encodeURIComponent(String(organizationId))}/model-provider-secrets`, method: 'GET', signal
    },
      options);
    }




export const getListOrgModelProviderSecretsQueryKey = (organizationId: string,) => {
    return [
    `/organizations/${organizationId}/model-provider-secrets`
    ] as const;
    }


export const getListOrgModelProviderSecretsQueryOptions = <TData = Awaited<ReturnType<typeof listOrgModelProviderSecrets>>, TError = unknown>(organizationId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOrgModelProviderSecrets>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOrgModelProviderSecretsQueryKey(organizationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOrgModelProviderSecrets>>> = ({ signal }) => listOrgModelProviderSecrets(organizationId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: organizationId !== null && organizationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOrgModelProviderSecrets>>, TError, TData> & { queryKey: QueryKey }
}

export type ListOrgModelProviderSecretsQueryResult = NonNullable<Awaited<ReturnType<typeof listOrgModelProviderSecrets>>>
export type ListOrgModelProviderSecretsQueryError = unknown


/**
 * @summary List the org's model provider keys.
 */

export function useListOrgModelProviderSecrets<TData = Awaited<ReturnType<typeof listOrgModelProviderSecrets>>, TError = unknown>(
 organizationId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOrgModelProviderSecrets>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListOrgModelProviderSecretsQueryOptions(organizationId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Add a model provider key for the org.
 */
export const createOrgModelProviderSecret = (
    organizationId: string,
    createOrgModelProviderSecretBody: CreateOrgModelProviderSecretBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/organizations/${encodeURIComponent(String(organizationId))}/model-provider-secrets`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createOrgModelProviderSecretBody, signal
    },
      options);
    }




export const getCreateOrgModelProviderSecretMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrgModelProviderSecret>>, TError,{organizationId: string;data: CreateOrgModelProviderSecretBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createOrgModelProviderSecret>>, TError,{organizationId: string;data: CreateOrgModelProviderSecretBody}, TContext> => {

const mutationKey = ['createOrgModelProviderSecret'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOrgModelProviderSecret>>, {organizationId: string;data: CreateOrgModelProviderSecretBody}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  createOrgModelProviderSecret(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOrgModelProviderSecretMutationResult = NonNullable<Awaited<ReturnType<typeof createOrgModelProviderSecret>>>
    export type CreateOrgModelProviderSecretMutationBody = CreateOrgModelProviderSecretBody
    export type CreateOrgModelProviderSecretMutationError = unknown

    /**
 * @summary Add a model provider key for the org.
 */
export const useCreateOrgModelProviderSecret = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrgModelProviderSecret>>, TError,{organizationId: string;data: CreateOrgModelProviderSecretBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createOrgModelProviderSecret>>,
        TError,
        {organizationId: string;data: CreateOrgModelProviderSecretBody},
        TContext
      > => {
      return useMutation(getCreateOrgModelProviderSecretMutationOptions(options));
    }
    /**
 * @summary Update an org model provider key.
 */
export const updateOrgModelProviderSecret = (
    organizationId: string,
    id: string,
    updateOrgModelProviderSecretBody: UpdateOrgModelProviderSecretBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/organizations/${encodeURIComponent(String(organizationId))}/model-provider-secrets/${encodeURIComponent(String(id))}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateOrgModelProviderSecretBody, signal
    },
      options);
    }




export const getUpdateOrgModelProviderSecretMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrgModelProviderSecret>>, TError,{organizationId: string;id: string;data: UpdateOrgModelProviderSecretBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOrgModelProviderSecret>>, TError,{organizationId: string;id: string;data: UpdateOrgModelProviderSecretBody}, TContext> => {

const mutationKey = ['updateOrgModelProviderSecret'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOrgModelProviderSecret>>, {organizationId: string;id: string;data: UpdateOrgModelProviderSecretBody}> = (props) => {
          const {organizationId,id,data} = props ?? {};

          return  updateOrgModelProviderSecret(organizationId,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOrgModelProviderSecretMutationResult = NonNullable<Awaited<ReturnType<typeof updateOrgModelProviderSecret>>>
    export type UpdateOrgModelProviderSecretMutationBody = UpdateOrgModelProviderSecretBody
    export type UpdateOrgModelProviderSecretMutationError = unknown

    /**
 * @summary Update an org model provider key.
 */
export const useUpdateOrgModelProviderSecret = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrgModelProviderSecret>>, TError,{organizationId: string;id: string;data: UpdateOrgModelProviderSecretBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateOrgModelProviderSecret>>,
        TError,
        {organizationId: string;id: string;data: UpdateOrgModelProviderSecretBody},
        TContext
      > => {
      return useMutation(getUpdateOrgModelProviderSecretMutationOptions(options));
    }
    /**
 * @summary Delete an org model provider key.
 */
export const deleteOrgModelProviderSecret = (
    organizationId: string,
    id: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/organizations/${encodeURIComponent(String(organizationId))}/model-provider-secrets/${encodeURIComponent(String(id))}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteOrgModelProviderSecretMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOrgModelProviderSecret>>, TError,{organizationId: string;id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteOrgModelProviderSecret>>, TError,{organizationId: string;id: string}, TContext> => {

const mutationKey = ['deleteOrgModelProviderSecret'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteOrgModelProviderSecret>>, {organizationId: string;id: string}> = (props) => {
          const {organizationId,id} = props ?? {};

          return  deleteOrgModelProviderSecret(organizationId,id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteOrgModelProviderSecretMutationResult = NonNullable<Awaited<ReturnType<typeof deleteOrgModelProviderSecret>>>

    export type DeleteOrgModelProviderSecretMutationError = unknown

    /**
 * @summary Delete an org model provider key.
 */
export const useDeleteOrgModelProviderSecret = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOrgModelProviderSecret>>, TError,{organizationId: string;id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteOrgModelProviderSecret>>,
        TError,
        {organizationId: string;id: string},
        TContext
      > => {
      return useMutation(getDeleteOrgModelProviderSecretMutationOptions(options));
    }
    /**
 * @summary List what depends on an org model provider key.
 */
export const listOrgModelProviderSecretDependents = (
    organizationId: string,
    id: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<ListOrgModelProviderSecretDependents200>(
      {url: `/organizations/${encodeURIComponent(String(organizationId))}/model-provider-secrets/${encodeURIComponent(String(id))}/dependents`, method: 'GET', signal
    },
      options);
    }




export const getListOrgModelProviderSecretDependentsQueryKey = (organizationId: string,
    id: string,) => {
    return [
    `/organizations/${organizationId}/model-provider-secrets/${id}/dependents`
    ] as const;
    }


export const getListOrgModelProviderSecretDependentsQueryOptions = <TData = Awaited<ReturnType<typeof listOrgModelProviderSecretDependents>>, TError = unknown>(organizationId: string,
    id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOrgModelProviderSecretDependents>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOrgModelProviderSecretDependentsQueryKey(organizationId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOrgModelProviderSecretDependents>>> = ({ signal }) => listOrgModelProviderSecretDependents(organizationId,id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: organizationId !== null && organizationId !== undefined && id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOrgModelProviderSecretDependents>>, TError, TData> & { queryKey: QueryKey }
}

export type ListOrgModelProviderSecretDependentsQueryResult = NonNullable<Awaited<ReturnType<typeof listOrgModelProviderSecretDependents>>>
export type ListOrgModelProviderSecretDependentsQueryError = unknown


/**
 * @summary List what depends on an org model provider key.
 */

export function useListOrgModelProviderSecretDependents<TData = Awaited<ReturnType<typeof listOrgModelProviderSecretDependents>>, TError = unknown>(
 organizationId: string,
    id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOrgModelProviderSecretDependents>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListOrgModelProviderSecretDependentsQueryOptions(organizationId,id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary List a team's model provider keys.
 */
export const listTeamModelProviderSecrets = (
    organizationId: string,
    teamId: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/organizations/${encodeURIComponent(String(organizationId))}/teams/${encodeURIComponent(String(teamId))}/model-provider-secrets`, method: 'GET', signal
    },
      options);
    }




export const getListTeamModelProviderSecretsQueryKey = (organizationId: string,
    teamId: string,) => {
    return [
    `/organizations/${organizationId}/teams/${teamId}/model-provider-secrets`
    ] as const;
    }


export const getListTeamModelProviderSecretsQueryOptions = <TData = Awaited<ReturnType<typeof listTeamModelProviderSecrets>>, TError = unknown>(organizationId: string,
    teamId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTeamModelProviderSecrets>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTeamModelProviderSecretsQueryKey(organizationId,teamId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTeamModelProviderSecrets>>> = ({ signal }) => listTeamModelProviderSecrets(organizationId,teamId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: organizationId !== null && organizationId !== undefined && teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTeamModelProviderSecrets>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTeamModelProviderSecretsQueryResult = NonNullable<Awaited<ReturnType<typeof listTeamModelProviderSecrets>>>
export type ListTeamModelProviderSecretsQueryError = unknown


/**
 * @summary List a team's model provider keys.
 */

export function useListTeamModelProviderSecrets<TData = Awaited<ReturnType<typeof listTeamModelProviderSecrets>>, TError = unknown>(
 organizationId: string,
    teamId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTeamModelProviderSecrets>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTeamModelProviderSecretsQueryOptions(organizationId,teamId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Add a model provider key for a team.
 */
export const createTeamModelProviderSecret = (
    organizationId: string,
    teamId: string,
    createTeamModelProviderSecretBody: CreateTeamModelProviderSecretBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<ModelProviderSecret>(
      {url: `/organizations/${encodeURIComponent(String(organizationId))}/teams/${encodeURIComponent(String(teamId))}/model-provider-secrets`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createTeamModelProviderSecretBody, signal
    },
      options);
    }




export const getCreateTeamModelProviderSecretMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTeamModelProviderSecret>>, TError,{organizationId: string;teamId: string;data: CreateTeamModelProviderSecretBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTeamModelProviderSecret>>, TError,{organizationId: string;teamId: string;data: CreateTeamModelProviderSecretBody}, TContext> => {

const mutationKey = ['createTeamModelProviderSecret'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTeamModelProviderSecret>>, {organizationId: string;teamId: string;data: CreateTeamModelProviderSecretBody}> = (props) => {
          const {organizationId,teamId,data} = props ?? {};

          return  createTeamModelProviderSecret(organizationId,teamId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTeamModelProviderSecretMutationResult = NonNullable<Awaited<ReturnType<typeof createTeamModelProviderSecret>>>
    export type CreateTeamModelProviderSecretMutationBody = CreateTeamModelProviderSecretBody
    export type CreateTeamModelProviderSecretMutationError = unknown

    /**
 * @summary Add a model provider key for a team.
 */
export const useCreateTeamModelProviderSecret = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTeamModelProviderSecret>>, TError,{organizationId: string;teamId: string;data: CreateTeamModelProviderSecretBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTeamModelProviderSecret>>,
        TError,
        {organizationId: string;teamId: string;data: CreateTeamModelProviderSecretBody},
        TContext
      > => {
      return useMutation(getCreateTeamModelProviderSecretMutationOptions(options));
    }
    /**
 * @summary Update a team model provider key.
 */
export const updateTeamModelProviderSecret = (
    organizationId: string,
    teamId: string,
    id: string,
    updateTeamModelProviderSecretBody: UpdateTeamModelProviderSecretBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/organizations/${encodeURIComponent(String(organizationId))}/teams/${encodeURIComponent(String(teamId))}/model-provider-secrets/${encodeURIComponent(String(id))}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateTeamModelProviderSecretBody, signal
    },
      options);
    }




export const getUpdateTeamModelProviderSecretMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTeamModelProviderSecret>>, TError,{organizationId: string;teamId: string;id: string;data: UpdateTeamModelProviderSecretBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTeamModelProviderSecret>>, TError,{organizationId: string;teamId: string;id: string;data: UpdateTeamModelProviderSecretBody}, TContext> => {

const mutationKey = ['updateTeamModelProviderSecret'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTeamModelProviderSecret>>, {organizationId: string;teamId: string;id: string;data: UpdateTeamModelProviderSecretBody}> = (props) => {
          const {organizationId,teamId,id,data} = props ?? {};

          return  updateTeamModelProviderSecret(organizationId,teamId,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTeamModelProviderSecretMutationResult = NonNullable<Awaited<ReturnType<typeof updateTeamModelProviderSecret>>>
    export type UpdateTeamModelProviderSecretMutationBody = UpdateTeamModelProviderSecretBody
    export type UpdateTeamModelProviderSecretMutationError = unknown

    /**
 * @summary Update a team model provider key.
 */
export const useUpdateTeamModelProviderSecret = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTeamModelProviderSecret>>, TError,{organizationId: string;teamId: string;id: string;data: UpdateTeamModelProviderSecretBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateTeamModelProviderSecret>>,
        TError,
        {organizationId: string;teamId: string;id: string;data: UpdateTeamModelProviderSecretBody},
        TContext
      > => {
      return useMutation(getUpdateTeamModelProviderSecretMutationOptions(options));
    }
    /**
 * @summary Delete a team model provider key.
 */
export const deleteTeamModelProviderSecret = (
    organizationId: string,
    teamId: string,
    id: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/organizations/${encodeURIComponent(String(organizationId))}/teams/${encodeURIComponent(String(teamId))}/model-provider-secrets/${encodeURIComponent(String(id))}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteTeamModelProviderSecretMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTeamModelProviderSecret>>, TError,{organizationId: string;teamId: string;id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTeamModelProviderSecret>>, TError,{organizationId: string;teamId: string;id: string}, TContext> => {

const mutationKey = ['deleteTeamModelProviderSecret'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTeamModelProviderSecret>>, {organizationId: string;teamId: string;id: string}> = (props) => {
          const {organizationId,teamId,id} = props ?? {};

          return  deleteTeamModelProviderSecret(organizationId,teamId,id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTeamModelProviderSecretMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTeamModelProviderSecret>>>

    export type DeleteTeamModelProviderSecretMutationError = unknown

    /**
 * @summary Delete a team model provider key.
 */
export const useDeleteTeamModelProviderSecret = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTeamModelProviderSecret>>, TError,{organizationId: string;teamId: string;id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteTeamModelProviderSecret>>,
        TError,
        {organizationId: string;teamId: string;id: string},
        TContext
      > => {
      return useMutation(getDeleteTeamModelProviderSecretMutationOptions(options));
    }
    /**
 * @summary List a team's secrets without their values.
 */
export const listTeamSecrets = (
    organizationId: string,
    teamId: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<ListTeamSecrets200>(
      {url: `/organizations/${encodeURIComponent(String(organizationId))}/teams/${encodeURIComponent(String(teamId))}/secrets`, method: 'GET', signal
    },
      options);
    }




export const getListTeamSecretsQueryKey = (organizationId: string,
    teamId: string,) => {
    return [
    `/organizations/${organizationId}/teams/${teamId}/secrets`
    ] as const;
    }


export const getListTeamSecretsQueryOptions = <TData = Awaited<ReturnType<typeof listTeamSecrets>>, TError = unknown>(organizationId: string,
    teamId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTeamSecrets>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTeamSecretsQueryKey(organizationId,teamId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTeamSecrets>>> = ({ signal }) => listTeamSecrets(organizationId,teamId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: organizationId !== null && organizationId !== undefined && teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTeamSecrets>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTeamSecretsQueryResult = NonNullable<Awaited<ReturnType<typeof listTeamSecrets>>>
export type ListTeamSecretsQueryError = unknown


/**
 * @summary List a team's secrets without their values.
 */

export function useListTeamSecrets<TData = Awaited<ReturnType<typeof listTeamSecrets>>, TError = unknown>(
 organizationId: string,
    teamId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTeamSecrets>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTeamSecretsQueryOptions(organizationId,teamId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Create a secret owned by the team.
 */
export const createTeamSecret = (
    organizationId: string,
    teamId: string,
    createTeamSecretBody: CreateTeamSecretBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<ScopedSecret>(
      {url: `/organizations/${encodeURIComponent(String(organizationId))}/teams/${encodeURIComponent(String(teamId))}/secrets`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createTeamSecretBody, signal
    },
      options);
    }




export const getCreateTeamSecretMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTeamSecret>>, TError,{organizationId: string;teamId: string;data: CreateTeamSecretBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTeamSecret>>, TError,{organizationId: string;teamId: string;data: CreateTeamSecretBody}, TContext> => {

const mutationKey = ['createTeamSecret'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTeamSecret>>, {organizationId: string;teamId: string;data: CreateTeamSecretBody}> = (props) => {
          const {organizationId,teamId,data} = props ?? {};

          return  createTeamSecret(organizationId,teamId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTeamSecretMutationResult = NonNullable<Awaited<ReturnType<typeof createTeamSecret>>>
    export type CreateTeamSecretMutationBody = CreateTeamSecretBody
    export type CreateTeamSecretMutationError = unknown

    /**
 * @summary Create a secret owned by the team.
 */
export const useCreateTeamSecret = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTeamSecret>>, TError,{organizationId: string;teamId: string;data: CreateTeamSecretBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTeamSecret>>,
        TError,
        {organizationId: string;teamId: string;data: CreateTeamSecretBody},
        TContext
      > => {
      return useMutation(getCreateTeamSecretMutationOptions(options));
    }
    /**
 * @summary Update a team secret's name or value.
 */
export const updateTeamSecret = (
    organizationId: string,
    teamId: string,
    id: string,
    updateTeamSecretBody: UpdateTeamSecretBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<ScopedSecret>(
      {url: `/organizations/${encodeURIComponent(String(organizationId))}/teams/${encodeURIComponent(String(teamId))}/secrets/${encodeURIComponent(String(id))}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateTeamSecretBody, signal
    },
      options);
    }




export const getUpdateTeamSecretMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTeamSecret>>, TError,{organizationId: string;teamId: string;id: string;data: UpdateTeamSecretBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTeamSecret>>, TError,{organizationId: string;teamId: string;id: string;data: UpdateTeamSecretBody}, TContext> => {

const mutationKey = ['updateTeamSecret'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTeamSecret>>, {organizationId: string;teamId: string;id: string;data: UpdateTeamSecretBody}> = (props) => {
          const {organizationId,teamId,id,data} = props ?? {};

          return  updateTeamSecret(organizationId,teamId,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTeamSecretMutationResult = NonNullable<Awaited<ReturnType<typeof updateTeamSecret>>>
    export type UpdateTeamSecretMutationBody = UpdateTeamSecretBody
    export type UpdateTeamSecretMutationError = unknown

    /**
 * @summary Update a team secret's name or value.
 */
export const useUpdateTeamSecret = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTeamSecret>>, TError,{organizationId: string;teamId: string;id: string;data: UpdateTeamSecretBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateTeamSecret>>,
        TError,
        {organizationId: string;teamId: string;id: string;data: UpdateTeamSecretBody},
        TContext
      > => {
      return useMutation(getUpdateTeamSecretMutationOptions(options));
    }
    /**
 * @summary Delete a team secret.
 */
export const deleteTeamSecret = (
    organizationId: string,
    teamId: string,
    id: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/organizations/${encodeURIComponent(String(organizationId))}/teams/${encodeURIComponent(String(teamId))}/secrets/${encodeURIComponent(String(id))}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteTeamSecretMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTeamSecret>>, TError,{organizationId: string;teamId: string;id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTeamSecret>>, TError,{organizationId: string;teamId: string;id: string}, TContext> => {

const mutationKey = ['deleteTeamSecret'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTeamSecret>>, {organizationId: string;teamId: string;id: string}> = (props) => {
          const {organizationId,teamId,id} = props ?? {};

          return  deleteTeamSecret(organizationId,teamId,id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTeamSecretMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTeamSecret>>>

    export type DeleteTeamSecretMutationError = unknown

    /**
 * @summary Delete a team secret.
 */
export const useDeleteTeamSecret = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTeamSecret>>, TError,{organizationId: string;teamId: string;id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteTeamSecret>>,
        TError,
        {organizationId: string;teamId: string;id: string},
        TContext
      > => {
      return useMutation(getDeleteTeamSecretMutationOptions(options));
    }
